import React from "react";

type Props = {
  value: string;
  onChange: (value: string) => void;
  invalid: boolean;
};

/**
 * The video-call link for a client whose appointments are online. Rendered only
 * when the client's script says so (`visitMode === "online"`), so a school's
 * settings screen stays as it was.
 */
export function MeetingLinkSettings({ value, onChange, invalid }: Props): React.JSX.Element {
  return (
    <div className="border-t border-ink-200 pt-4 mt-4">
      <div className="mb-1">
        <p className="text-[13px] font-medium text-ink-900">Enlace de videollamada</p>
        <p className="text-[12px] text-ink-500 mt-0.5">
          Va en la invitación y en el recordatorio de cada cita en línea. Sin enlace, la
          invitación dice que el asesor lo compartirá.
        </p>
      </div>

      <input
        type="url"
        inputMode="url"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        maxLength={500}
        placeholder="https://meet.google.com/…"
        className={`mt-3 w-full text-[13px] border rounded-lg px-3 py-1.5 focus:outline-none text-ink-900 placeholder:text-ink-300 bg-white ${
          invalid ? "border-red-400 focus:border-red-500" : "border-ink-200 focus:border-moss"
        }`}
      />
      {invalid && (
        <p className="text-[11px] text-red-500 mt-1">
          Ingresa una URL válida que empiece con https:// o http://
        </p>
      )}
    </div>
  );
}
